import { trackApiClient } from '@/clients/TrackApiClient';
import { ITrackLookupResult } from '@/data/models/track';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useLookupTracksQuery(
  isrc: string,
  source: 'physical' | 'digital',
  labelId?: string
): UseQueryResult<ITrackLookupResult[], Error> {
  async function queryFn() {
    const response = await trackApiClient.lookupTracksByIsrc(
      isrc,
      source,
      labelId
    );
    return response.data?.results || [];
  }

  return useQuery({
    queryFn,
    queryKey: ['tracks-lookup', isrc, source, labelId],
    staleTime: 10000,
    enabled: !!isrc,
  });
}
